import React from "react";
import "./Steps.scss";
import { CheckCircleFilled } from "@ant-design/icons";
import { Col, Flex, Row, Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { DESC_TXT, TITLE_TXT } from "../../constants/constants";

const { Text } = Typography;

export const VerticalSteps = ({ dealBookedDate, repaymentDate }) => {
    return (
        <div className="steps-container">
            <Row gutter={[16, 0]}>
                <Col>
                    <div className="steps-progress-container">
                        <CheckCircleFilled style={{ color: "#00874F", fontSize: 20 }} />
                        <div className="steps-divider" />
                        <div className="step" />
                        <div className="steps-divider" />
                        <div className="step" />
                    </div>
                </Col>
                <Col>
                    <div className="steps-details-container">
                        <Flex vertical>
                            <Text strong>{TITLE_TXT.DEAL_BOOKED}</Text>
                            <Text style={{ color: "#40566D", fontSize: 12 }}>
                                {dealBookedDate}
                            </Text>
                        </Flex>
                        <Flex vertical>
                            <Text strong>{TITLE_TXT.DEAL_EXEC}</Text>
                            <Text style={{ color: "#40566D", fontSize: 12 }}>
                                {DESC_TXT.AWAT_APP_BY_BUS}
                            </Text>
                        </Flex>
                        <Flex vertical>
                            <Text strong>{TITLE_TXT.REPAYMENT}</Text>
                            <Text style={{ color: "#40566D", fontSize: 12 }}>
                                {repaymentDate}
                            </Text>
                        </Flex>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export const HorizotalSteps = ({
    dealBookedDate,
    dealExecutedDate,
    dealDisbursedDate,
    status,
    repaymentDate,
    repaidDate,
}) => {
    return (
        <div className="horizontal-steps-container">
            <Row gutter={[16, 16]} className="row">
                <Col>
                    <div className="step-details">
                        <CheckCircleFilled style={{ color: "#00874F", fontSize: 20 }} />
                        <Text strong style={{ fontSize: 14 }}>
                            {TITLE_TXT.DEAL_BOOKED}
                        </Text>
                    </div>
                </Col>
                <Col xs={{ flex: "auto" }}>
                    <div className="horizontal-step-divider" />
                </Col>
                <Col>
                    <div className="step-details">
                        {dealExecutedDate ? (
                            <CheckCircleFilled style={{ color: "#00874F", fontSize: 20 }} />
                        ) : (
                            <div className="horizontal-step" />
                        )}
                        <Text strong style={{ fontSize: 14 }}>
                            {TITLE_TXT.DEAL_EXEC}
                        </Text>
                    </div>
                </Col>
                <Col xs={{ flex: "auto" }}>
                    <div className="horizontal-step-divider" />
                </Col>
                <Col>
                    <div className="step-details">
                        {dealDisbursedDate ? (
                            <CheckCircleFilled style={{ color: "#00874F", fontSize: 20 }} />
                        ) : (
                            <div className="horizontal-step" />
                        )}
                        <Text strong style={{ fontSize: 14 }}>
                            {TITLE_TXT.DEAL_DIS}
                        </Text>
                    </div>
                </Col>
                <Col xs={{ flex: "auto" }}>
                    <div className="horizontal-step-divider" />
                </Col>
                <Col>
                    <div className="step-details">
                        {repaidDate ? (
                            <CheckCircleFilled style={{ color: "#00874F", fontSize: 20 }} />
                        ) : (
                            <div className="horizontal-step" />
                        )}
                        <Flex gap="small">
                            <Text strong style={{ fontSize: 14 }}>
                                {status === "repaid" ? TITLE_TXT.REPAID : TITLE_TXT.REPAYMENT}
                            </Text>
                            {!repaidDate && (
                                <Tooltip title="This is an Estimated Repayment Date.">
                                    <InfoCircleOutlined
                                        className="info-icon"
                                        rotate={180}
                                        style={{ color: "#40566D", fontSize: 12 }}
                                    />
                                </Tooltip>
                            )}
                        </Flex>
                    </div>
                </Col>
            </Row>
            <Row className="step-subdetails-web">
                <Col span={3} style={{ textAlign: "center" }}>
                    <Text style={{ color: "#40566D", fontSize: 12 }}>
                        {dealBookedDate}
                    </Text>
                </Col>
                <Col xs={{ flex: "auto" }}></Col>
                <Col span={3} style={{ textAlign: "center" }}>
                    <Text style={{ color: "#40566D", fontSize: 12 }}>
                        {dealExecutedDate ? dealExecutedDate : DESC_TXT.AWAT_SIGN_AGG}
                    </Text>
                </Col>
                <Col xs={{ flex: "auto" }}></Col>
                <Col span={3} style={{ textAlign: "center", marginRight: status === "repaid" ? -20 : 0  }}>
                    <Text style={{ color: "#40566D", fontSize: 12 }}>
                        {dealDisbursedDate ? dealDisbursedDate : DESC_TXT.AWAT_APP_BY_BUS}
                    </Text>
                </Col>
                <Col xs={{ flex: "auto" }}></Col>
                <Col span={3} style={{ textAlign: "center", marginRight: status === "repaid" ? -30 : 0 }}>
                    <Text style={{ color: "#40566D", fontSize: 12 }}>
                        {repaidDate ? repaidDate : repaymentDate}
                    </Text>
                </Col>
            </Row>
            <Row className="step-subdetails-mobile" justify="space-between">
                <Col xs={6}>
                    <Flex vertical justify="center">
                        <Text strong style={{ fontSize: 14 }}>
                            {TITLE_TXT.DEAL_BOOKED}
                        </Text>
                        <Text style={{ color: "#40566D", fontSize: 12 }}>
                            {dealBookedDate}
                        </Text>
                    </Flex>
                </Col>
                <Col xs={6}>
                    <Flex vertical justify="center" align="center">
                        <Text strong style={{ fontSize: 14, textAlign: "center" }}>
                            {TITLE_TXT.DEAL_EXEC}
                        </Text>
                        <Text
                            style={{ color: "#40566D", fontSize: 12, textAlign: "center" }}
                        >
                            {dealExecutedDate ? dealExecutedDate : DESC_TXT.AWAT_SIGN_AGG}
                        </Text>
                    </Flex>
                </Col>
                <Col xs={6}>
                    <Flex vertical justify="center" align="center">
                        <Text strong style={{ fontSize: 14, textAlign: "center" }}>
                            {TITLE_TXT.DEAL_DIS}
                        </Text>
                        <Text
                            style={{ color: "#40566D", fontSize: 12, textAlign: "center" }}
                        >
                            {dealDisbursedDate ? dealDisbursedDate : DESC_TXT.AWAT_APP_BY_BUS}
                        </Text>
                    </Flex>
                </Col>
                <Col xs={6}>
                    <Flex vertical justify="center" align="flex-end">
                        <Flex gap="small" wrap justify="center">
                            <Text strong style={{ fontSize: 14 }}>
                                {status === "repaid" ? TITLE_TXT.REPAID : TITLE_TXT.REPAYMENT}
                            </Text>
                            {!repaidDate && (
                                <Tooltip title="This is an Estimated Repayment Date.">
                                    <InfoCircleOutlined
                                        rotate={180}
                                        style={{ color: "#40566D", fontSize: 12 }}
                                    />
                                </Tooltip>
                            )}
                        </Flex>
                        <Text style={{ color: "#40566D", fontSize: 12 }}>
                            {repaidDate ? repaidDate : repaymentDate}
                        </Text>
                    </Flex>
                </Col>
            </Row>
        </div>
    );
};
